import React from "react";
import DropdownList from "react-widgets/DropdownList";
import { TipoClave } from "./ComboSelector.js";
import { ApellidoNombrePuesto } from "../../funciones/FuncionesPersona.js";
import "./ComboSelector.scss";

const ComboSelectorJugador = (props) => {
  const id = props.id;
  const lista = props.lista;
  const valorActual = props.valorActual;
  const isCargando = props.isCargando;
  const estilo = props.estilo;

  //console.log("ComboSelectorJugador", id, lista, valorActual, isCargando);
  const listaConvertida = lista.map((item) => {
    return {
      ...item,
      personaConPuesto: ApellidoNombrePuesto(item),
    };
  });

  const onItemElegido = (item) => {
    props.onItemElegido(item);
  };

  return (
    <React.Fragment>
      <DropdownList
        key={id}
        className={estilo}
        busy={isCargando}
        filter="contains"
        datakey={TipoClave.ID}
        textField={"personaConPuesto"}
        value={valorActual}
        data={listaConvertida}
        onChange={onItemElegido}
      />
    </React.Fragment>
  );
};

export default ComboSelectorJugador;
